import { render, staticRenderFns } from "./CertificateInfo.vue?vue&type=template&id=051edc37&"
import script from "./CertificateInfo.vue?vue&type=script&lang=js&"
export * from "./CertificateInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports